__turbopack_context__.v({
  "container": "GroupOrderMaxAttendeeLimitNote-module-scss-module__zX_7za__container",
});
